module.exports = __webpack_public_path__ + "static/img/hh-conference.35b5dc59.png";